





























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ApiBrand from '@/models/api/brand'
import DropdownSelect from '@spa/components/atoms/DropdownSelect.vue'
import { SelectItem } from '@spa/components/atoms/model/SelectItem'
import FavoriteItemsView from '@spa/components/templates/FavoriteItems.vue'

@Component({
  components: {
    DropdownSelect,
    FavoriteItemsView,
  },
})
export default class FavoriteItems extends Vue {

  @Prop({ required: true })
  initialBrandId: string

  @Prop({ required: true })
  brands: ApiBrand[]

  selectedBrandId: string = ''

  async created() {
    this.selectedBrandId = this.initialBrandId
  }

  get selectList(): SelectItem[] {
    return this.brands
      .map(brand => ({
        text: brand.name,
        value: brand.id,
        selected: brand.id === this.selectedBrandId,
        disabled: false,
      }))
  }

  shouldShow(brandId: string): boolean {
    return brandId === this.selectedBrandId
  }

  onSelect(brandId: string) {
    this.selectedBrandId = brandId
  }
}
